import request from '../request'

export const getSetting = (data) => request.get(`/periodical-report/setting`, data).then((res) => res)

export const getSettingSubModule = (type, data) =>
  request.get(`/periodical-report/setting/${type}`, data).then((res) => res)

export const updateSetting = (data) => request.put(`/periodical-report/setting`, data).then((res) => res)

export const createSubModule = (data, type) =>
  request.post(`/periodical-report/setting/${type}`, data).then((res) => res)

export const updateSubModule = (settingIdId, type, data) =>
  request.put(`/periodical-report/setting/${type}/${settingIdId}`, data).then((res) => res)

export const updateLevelAssessmentaArea = (settingIdId, levelId, data) =>
  request
    .put(`/periodical-report/setting/assessment-area/${settingIdId}/level/${levelId}`, data)
    .then((res) => res)

export const deleteSubModule = (settingIdId, type) =>
  request.delete(`/periodical-report/setting/${type}/${settingIdId}`).then((res) => res)
